import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import UserNavbar from "./UserNavbar";
import { useNavigate } from "react-router-dom";

const AddNewDecoder = () => {
  const [fileName, setFileName] = useState("");
  const [code, setCode] = useState("<!-- Modify it at your will. -->");

  const navigate = useNavigate();
  const token = Cookies.get("token");
  const role = Cookies.get("role");
  const [error, setError] = useState("");

  useEffect(() => {
    if (token && role) {
      if (role === "3") {
        navigate("/dashboard");
      }
    }
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/signin");
    } else {
      axios
        .get("/api/token/isLoggedIn", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => console.log(res.data))
        .catch(() => navigate("/signin"));
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`/api/system/decoders/${fileName}`, code, {
        headers: {
          "x-auth-token": token,
          "Content-Type": "application/octet-stream",
        },
      })
      .then((res) => {
        if (res.data.error === 0) {
          navigate("/managedecoders");
        } else {
          setError(res.data.data.failed_items[0].error.message);
          setTimeout(() => {
            setError("");
          }, 1000);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <UserNavbar />

      <div className="px-4 lg:pt-10 lg:w-[80vw] xl:w-[85vw] lg:absolute lg:right-0 lg:px-6 xl:absolute xl:right-0  xl:pt-20 xl:pb-12 h-full bg-gray-50">
        <div className="p-6 bg-white shadow-md rounded-md w-full max-w-full mx-auto border border-gray-100">
          <div className="flex justify-between items-center mb-4">
            <div>
              <i
                className="cursor-pointer ri-arrow-left-s-line text-blue-500 font-bold text-[1.5rem] pr-2 align-middle"
                onClick={() => navigate("/managerules")}
              ></i>

              <input
                type="text"
                placeholder="Type your new rules file name here"
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
                className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
              />
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleSubmit}
                disabled={!fileName.trim() || !code.trim()}
                className={`px-4 py-2 rounded-md text-white transition ${
                  !fileName.trim() || !code.trim()
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 hover:bg-blue-600"
                }`}
              >
                <i className="ri-save-3-fill pr-2"></i>
                Save
              </button>
            </div>
          </div>

          {error && (
            <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200 text-red-600 text-sm text-center shadow-sm">
              {error}
            </div>
          )}

          <div className="border border-gray-200 rounded-md bg-gray-50 overflow-hidden">
            <textarea
              className="w-full h-[75vh] p-4 font-mono text-sm bg-gray-50 focus:outline-none resize-none"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewDecoder;
